import { ActionTree } from 'vuex';
import {
  mutationSetLoading,
  mutationSetLoaded,
  mutationSetPreview,
  mutationClearData,
  mutationSetURLValidation,
  mutationSetMessage,
} from '@/dealroom/content-link/store/content-link.mutations';
import { IContentLinkBlock } from '@/dealroom/content-link/types/content-link';
import {
  IContentLinkBlockState,
  state as defaultState,
} from '@/dealroom/content-link/store/content-link.store';
import { RootState } from '@/store/store';
import { ContentLinkBlockService } from '@/api/content-link/services/content-link-block.service';

export const actionPreview: string = 'preview';
export const actionPreviewSuccess: string = 'previewSuccess';
export const actionPreviewFailed: string = 'previewFailed';

export const actionSetPreview: string = 'setPreview';

export const actionSetURLValidation = 'setURLValidation';

export const actionUpdate: string = 'update';

export const actionPreviewScrapeFailed: string = 'previewScrapeFailed';

export const actionResetState: string = 'resetState';

export const actions: ActionTree<IContentLinkBlockState, RootState> = {
  async [actionPreview]({ commit, dispatch, state }) {
    try {
      commit(mutationSetLoading, true);
      commit(mutationSetLoaded, false);
      const contentLinkBlockPreview: Partial<IContentLinkBlock> = await ContentLinkBlockService.loadContentLinkBlockPreview(
        state.preview.url
      );
      dispatch(actionPreviewSuccess, contentLinkBlockPreview);
    } catch (error) {
      if (error.networkError) {
        dispatch(actionPreviewFailed);
      } else {
        dispatch(actionPreviewScrapeFailed, state.preview.url);
      }
    }
  },
  async [actionPreviewSuccess]({ commit }, contentLinkBlock: IContentLinkBlock) {
    commit(mutationSetLoading, false);
    commit(mutationSetLoaded, true);
    commit(mutationSetPreview, contentLinkBlock);
  },
  [actionPreviewFailed]({ commit }) {
    commit(mutationSetLoading, false);
    commit(mutationSetMessage, 'could-not-preview-url');
  },
  [actionPreviewScrapeFailed]({ commit, state }, contentLinkUrl: string) {
    commit(mutationSetLoading, false);
    commit(mutationSetMessage, 'could-not-get-data-from-url-but-you-can-still-create-link-block');
    const emptyContentLink: IContentLinkBlock = {
      title: '',
      description: '',
      url: '',
      buttonText: '',
      thumbUrl: '',
    };
    commit(mutationSetPreview, {
      ...emptyContentLink,
      url: contentLinkUrl,
      buttonText: state.preview.buttonText,
    });
  },
  [actionResetState]({ commit }) {
    commit(mutationClearData, { ...defaultState });
  },
  [actionUpdate]({ commit, state }, payload: Partial<IContentLinkBlock>) {
    const updatedContentLink: IContentLinkBlock = { ...state.preview, ...payload };
    commit(mutationSetPreview, updatedContentLink);
  },
  [actionSetURLValidation]({ commit, dispatch, state }, valid?: boolean) {
    commit(mutationSetURLValidation, valid);
    commit(mutationSetMessage, undefined);
    if (valid) {
      dispatch(actionPreview);
      return;
    }
    if (valid === false) {
      commit(mutationSetMessage, 'url-is-invalid');
    }
    commit(mutationSetLoaded, false);
    commit(mutationSetPreview, {
      ...defaultState.preview,
      url: state.preview.url,
      buttonText: state.preview.buttonText,
    });
  },
  [actionSetPreview]({ commit }, contentLinkBlock: IContentLinkBlock) {
    commit(mutationSetPreview, contentLinkBlock);
    commit(mutationSetLoaded, true);
  },
};
